// extracted by mini-css-extract-plugin
module.exports = {"form":"JoinGame_form__KbzuT"};